var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"nav-toc__toggle",class:{
    'nav-toc__toggle--is-expanded': _vm.internalIsExpanded,
  },attrs:{"aria-expanded":_vm.isExpanded ? 'true' : 'false'},on:{"click":_vm.toggle}},[_c('span',{staticClass:"nav-toc__icon",class:{
      'nav-toc__icon--close': _vm.isExpanded,
      'nav-toc__icon--open': !_vm.isExpanded,
    }},[_c('a-label',{attrs:{"path":_vm.isExpanded ? 'dossier.close' : 'dossier.open'}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }